import {Effect, effect} from '@mazechazer/redux-loop'

export function focus<T>(id: string, action: T): Effect<T> {
    return effect(() => {
        const element = document.getElementById(id)
        if (element !== null) {
            element.focus()
        }
        return Promise.resolve(action)
    })
}

export function scrollDivDown<T>(id: string, action: T): Effect<T> {
    return effect(() => {
        let scrollView = document.getElementById(id)
        if (scrollView !== null) {
            scrollView.scrollTop = scrollView.scrollHeight
        }
        return Promise.resolve(action)
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Dom.ts